import en from './locales/en.json'
import bs from './locales/bs.json'
import ru from './locales/ru.json'
import de from './locales/de.json'

export default {
  en,
  bs,
  ru,
  de
}
